var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcquiredIconBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 309,
    height: 309,
    viewBox: "0 0 309 309",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.283 0C69.2731 0 0 69.2731 0 154.283C0 239.293 69.2731 308.566 154.283 308.566C239.293 308.566 308.566 239.293 308.566 154.283C308.566 69.2731 239.293 0 154.283 0ZM228.03 118.798L140.552 206.276C138.392 208.436 135.461 209.671 132.375 209.671C129.289 209.671 126.358 208.436 124.198 206.276L80.5358 162.614C76.0615 158.14 76.0615 150.735 80.5358 146.26C85.01 141.786 92.4156 141.786 96.8898 146.26L132.375 181.745L211.676 102.444C216.151 97.9697 223.556 97.9697 228.03 102.444C232.505 106.918 232.505 114.169 228.03 118.798Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcquiredIconBadge);
export default __webpack_public_path__ + "static/media/acquiredIconBadge.5acb20157b341638a8e99930d0742f4f.svg";
export { ForwardRef as ReactComponent };